(ns practitest.frontend.stacked-progress-bar-chart
  (:require [practitest.frontend.common.utils :as utils]
            [practitest.frontend.init :as init]
            [practitest.frontend.components2.dashboard.chart :refer [chart]]))

(defn root-view [{:keys [data-item-id data-edit-url]}]
  [chart #:chart{:id       (parse-long data-item-id)
                 :edit-url data-edit-url}])

(defn ^:dev/after-load remount-roots []
  (init/remount-roots "stacked-progress-bar-chart-component" root-view))

(utils/register-webcomponent! "stacked-progress-bar-chart-component")
